'use client';

import React, { FC, PropsWithChildren } from 'react';
import { cn } from './cn';
import type { MessageBoxType } from './spec/messageBox';

export const MessageBox: FC<
  PropsWithChildren<{
    type: MessageBoxType;
    className?: string;
  }>
> = ({ type = 'yellow', className, children }) => {
  return (
    <div
      className={cn(
        'overflow-auto rounded-lg border-2 p-4',
        type === 'red' && 'border-coral-800 bg-coral-200 text-coral-800 shadow-[3px_3px_0px_0px_var(--coral-800)]',
        type === 'yellow' &&
          'border-yellow-800 bg-yellow-200 text-yellow-800 shadow-[3px_3px_0px_0px_var(--yellow-800)]',
        type === 'green' && 'border-green-700 bg-green-200 text-green-700 shadow-[3px_3px_0px_0px_var(--green-700)]',
        type === 'white' && 'border-black bg-white text-black shadow-[3px_3px_0px_0px_var(--black)]',
        className
      )}
    >
      {children}
    </div>
  );
};
